export const TITULO_ESQUECI_SENHA = 'Esqueci minha senha'
export const DESCRICAO_ESQUECI_SENHA = 'Informe seu e-mail ou CPF de cadastro para ser disparado o e-mail de recuperação'
export const LABEL_CAMPO_EMAIL = 'E-mail ou CPF'
export const BOTAO_CONFIRMAR = 'Confirmar'
export const BOTAO_VOLTAR = 'Voltar'
export const SUCESSO_ESQUECI_SENHA = 'Caso seu e-mail esteja correto, você receberá as instruções para alterar a sua senha.'
export const FALHA_ESQUECI_SENHA = 'Houve um problema ao tentar se comunicar com o servidor.'
export const EMAIL_INVALIDO = {
  'descricao': 'Verifique os dados informados e o desafio captcha e tente novamente.',
  'titulo': 'Houve um erro!'
}
